import utils from './utils'

window.addEventListener('popstate', () => {
  const from = utils.getStorage('location')
  if (!from || from.indexOf('conference') !== -1 || from.indexOf('micevideo') !== -1) {
    utils.setStorage('location', window.location.href)
    return
  }
  window.location.reload()
})